<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  count: { type: Number, default: 0 },
  tone: {
    type: String,
    default: 'default',
    validator: value =>
      ['critical', 'warning', 'primary', 'default'].includes(value),
  },
});

const emit = defineEmits(['open']);

const iconClass = computed(() =>
  props.count > 0 ? 'i-lucide-triangle-alert' : 'i-lucide-key-round'
);

const toneClasses = computed(
  () =>
    ({
      critical: 'bg-rose-100 text-rose-700',
      warning: 'bg-amber-100 text-amber-700',
      primary: 'bg-lais-primary-50 text-lais-primary',
      default: 'bg-[#f0f0ff] text-lais-primary',
    })[props.tone]
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <button
    type="button"
    class="flex min-h-[104px] w-full items-center gap-3 rounded-lais border border-lais-border bg-white p-4 text-left shadow-lais-card transition hover:border-lais-primary/40 hover:shadow-lais-pop focus-visible:outline focus-visible:outline-2 focus-visible:outline-lais-primary-50"
    @click="emit('open')"
  >
    <span
      class="grid size-10 shrink-0 place-items-center rounded-full"
      :class="toneClasses"
      aria-hidden="true"
    >
      <span class="size-5" :class="iconClass" />
    </span>
    <span class="min-w-0 flex-1">
      <span class="block text-[13px] font-semibold text-lais-text-muted">
        {{ title }}
      </span>
      <span class="mt-1 block text-[24px] font-semibold text-lais-text">
        {{ count }}
      </span>
      <span class="block truncate text-[12px] text-lais-text-muted">
        {{ subtitle }}
      </span>
    </span>
    <span
      v-if="count > 0"
      class="i-lucide-chevron-right size-5 shrink-0 text-lais-text-muted"
      aria-hidden="true"
    />
  </button>
</template>
